export default "audio/bot_destroyed.mp3";